import { FormattedMessage as FM } from "react-intl";

const _fmtCOP = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  minimumFractionDigits: 0,
});

export const fmtCOP = (n) => _fmtCOP.format(n ?? 0);

export const TextColumn = () => null;
TextColumn.columnDef = (props) => ({
  field: props.field,
  header: <FM id={props.labelId} />,
  body: (row) => {
    const value = props.getValue ? props.getValue(row) : row[props.field];
    return <span className={props.className || "text-zinc-800"}>{value}</span>;
  },
});

export const TwoLineColumn = () => null;
TwoLineColumn.columnDef = (props) => ({
  field: props.field,
  header: <FM id={props.labelId} />,
  body: (row) => {
    const secondary = props.getSecondary(row);
    return (
      <div className="flex flex-col">
        <span className="font-medium text-zinc-800">
          {props.getPrimary(row)}
        </span>
        <span className="text-[10px] text-zinc-400 truncate max-w-50">
          {secondary ||
            (props.fallbackId ? <FM id={props.fallbackId} /> : "\u2014")}
        </span>
      </div>
    );
  },
});

export const MoneyColumn = () => null;
MoneyColumn.columnDef = (props) => {
  const isBold = props.bold !== false;
  const showDash = props.dashIfEmpty === true;
  return {
    field: props.field,
    header: <FM id={props.labelId} />,
    body: (row) => {
      const value = row[props.field];
      if (showDash && !value) {
        return <span className="text-zinc-300">{"\u2014"}</span>;
      }
      const cn = isBold
        ? "font-black text-zinc-900"
        : "font-medium text-zinc-700";
      return <span className={cn}>{fmtCOP(value)}</span>;
    },
  };
};

export const ChipColumn = () => null;
ChipColumn.columnDef = (props) => {
  const cls = props.className || "bg-zinc-100 text-zinc-600";
  return {
    field: props.field,
    header: <FM id={props.labelId} />,
    body: (row) => (
      <span className={`text-xs font-medium px-2 py-1 rounded ${cls}`}>
        {row[props.field]}
      </span>
    ),
  };
};

export const StatusColumn = () => null;
StatusColumn.columnDef = (props) => {
  const fb = props.fallbackColor || "bg-zinc-100 text-zinc-600";
  return {
    field: props.field,
    header: <FM id={props.labelId} />,
    body: (row) => {
      const value = row[props.field];
      const colorClass = props?.colorMap[value] || fb;
      const label = props.getLabel ? props.getLabel(value) : value;
      return (
        <span
          className={
            "text-[10px] uppercase tracking-wider px-3 py-2 rounded-lg " +
            colorClass
          }
        >
          {label}
        </span>
      );
    },
  };
};

export const ActionsColumn = () => null;
ActionsColumn.columnDef = (props) => ({
  field: "actions",
  header: <FM id={props.labelId} />,
  body: (row) => {
    const handleClick = (action, ev) => {
      ev.stopPropagation();
      action.onClick(row);
    };
    return (
      <div className="flex gap-2">
        {props.actions
          .filter((a) => !a.show || a.show(row))
          .map((a) => (
            <a.Button
              key={a.key}
              content={a.content}
              color={a.color}
              size="xs"
              className="py-1 px-2 text-[10px]"
              onClick={(ev) => handleClick(a, ev)}
            />
          ))}
      </div>
    );
  },
});

export const MoneyInputColumn = () => null;
MoneyInputColumn.columnDef = (props) => ({
  field: props.field,
  header: <FM id={props.labelId} />,
  body: (row) => {
    const pendingAmount = row.residual_amount || 0;
    const inputAmount =
      row.inputAmount != null ? row.inputAmount : pendingAmount;
    const exceedsMax = inputAmount > pendingAmount;

    const onChange = (ev) => {
      const raw = ev.target.value.replace(/[^\d]/g, "");
      props.onChangeAmount(row.id, raw ? parseInt(raw, 10) : 0);
    };

    return (
      <div className="flex flex-col items-end gap-0.5">
        <input
          type="text"
          inputMode="numeric"
          value={fmtCOP(inputAmount)}
          onChange={onChange}
          className={
            "w-32 pl-3 pr-2 py-1.5 rounded-lg border text-right font-bold text-sm " +
            (exceedsMax
              ? "border-red-300 bg-red-50 text-red-700"
              : "border-zinc-200 bg-zinc-50 text-zinc-800") +
            " focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent transition"
          }
        />
        {exceedsMax && (
          <span className="text-[10px] text-red-500">
            <FM
              id="sale.sale.delivery.panel.modal.max_amount"
              values={{ amount: fmtCOP(pendingAmount) }}
            />
          </span>
        )}
        {!exceedsMax && inputAmount < pendingAmount && inputAmount > 0 && (
          <span className="text-[10px] text-orange-500">
            <FM
              id="sale.sale.delivery.panel.modal.remaining"
              values={{ amount: fmtCOP(pendingAmount - inputAmount) }}
            />
          </span>
        )}
      </div>
    );
  },
});

export const TextInputColumn = () => null;
TextInputColumn.columnDef = (props) => ({
  field: props.field,
  header: <FM id={props.labelId} />,
  body: (row) => (
    <input
      type="text"
      inputMode="text"
      value={props.getValue(row) ?? ""}
      onChange={(ev) => props.onChange(row.id, ev.target.value)}
      className="w-28 pl-3 pr-2 py-1.5 rounded-lg border border-zinc-200 bg-zinc-50 text-zinc-800 text-sm font-medium text-right focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-transparent transition"
      placeholder={props.placeholder}
    />
  ),
});
